export enum DragAndDropTableStatus {
    Loading,
    Saving,
    SaveError,
    GenericError,
    NoData,
}
